<div
  class="fleet-form-density -m-6 flex max-h-screen max-w-160 flex-col md:min-w-120"
  submitOnEnter
  (submitOnEnter)="confirm()"
>
  <!-- Header -->
  <div
    class="bg-primary text-on-primary flex h-16 flex-none items-center justify-between pl-6 pr-3 sm:pl-8 sm:pr-5"
  >
    <div class="text-lg font-medium">{{ data.title }}</div>
    <button mat-icon-button (click)="discard()" [tabIndex]="-1">
      <mat-icon
        class="text-current"
        [svgIcon]="'heroicons_outline:x-mark'"
      ></mat-icon>
    </button>
  </div>

  <!--
    Not wrapped in an `@if (form)`: the form is built as a field initializer so
    the input is always in the static template, which is what lets
    `cdkFocusInitial` find it on open.
  -->
  <form class="flex flex-auto flex-col overflow-y-auto p-6 sm:p-8" [formGroup]="form">
    <mat-form-field subscriptSizing="dynamic">
      <mat-label>Project name</mat-label>
      <input
        matInput
        cdkFocusInitial
        [formControlName]="'name'"
        placeholder="e.g. Autoscaling Demo"
      />
    </mat-form-field>

    <!-- Actions -->
    <div class="mt-6 flex justify-end">
      <button mat-stroked-button class="sm:mx-3" (click)="discard()">
        Discard
      </button>
      <button
        mat-flat-button
        [color]="'primary'"
        [disabled]="form.invalid"
        (click)="confirm()"
      >
        {{ data.confirmLabel }}
      </button>
    </div>
  </form>
</div>
